import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "menu-child-box" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "menu-child-name" }
const _hoisted_5 = {
  key: 0,
  class: "arrow-icon",
  src: "static/icon/arrow_right_blue.svg"
}
const _hoisted_6 = {
  key: 0,
  class: "menu-child-base"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comp_menu_child = _resolveComponent("comp-menu-child", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.child, (v, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "menu-child-item",
        key: idx
      }, [
        _createElementVNode("a", {
          class: "menu-child-item-box",
          href: v.href,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hide')))
        }, [
          _createElementVNode("img", {
            class: "menu-child-icon",
            src: 'static/icon/menu_icon/' + v.icon
          }, null, 8, _hoisted_3),
          _createElementVNode("p", _hoisted_4, _toDisplayString(v.name), 1),
          (v.child)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2),
        (v.child)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_comp_menu_child, {
                child: v.child,
                onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hide')))
              }, null, 8, ["child"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}